import { CSSProperties } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BookingPage from './pages/BookingPage';
import ReschedulePage from './pages/ReschedulePage';
import CancelPage from './pages/CancelPage';

export default function App() {
  const containerStyles: CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  };

  const headerStyles: CSSProperties = {
    padding: 'var(--spacing-xl)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    borderBottom: '1px solid var(--color-border)'
  };

  const logoStyles: CSSProperties = {
    height: '40px',
    width: 'auto'
  };

  const mainStyles: CSSProperties = {
    flex: 1,
    padding: 'var(--spacing-2xl) var(--spacing-md)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  const footerStyles: CSSProperties = {
    padding: 'var(--spacing-xl)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    fontSize: '0.875rem',
    borderTop: '1px solid var(--color-border)',
    background: 'white'
  };

  return (
    <BrowserRouter>
      <div style={containerStyles}>
        {/* Header with Logo */}
        <header style={headerStyles}>
          <img src="/next_agency_logo.svg" alt="NextAgency" style={logoStyles} />
        </header>

        {/* Main Content */}
        <main style={mainStyles}>
          <Routes>
            <Route path="/" element={<BookingPage />} />
            <Route path="/reschedule" element={<ReschedulePage />} />
            <Route path="/cancel" element={<CancelPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer style={footerStyles}>
          &copy; {new Date().getFullYear()} NextAgency. All rights reserved.
        </footer>
      </div>
    </BrowserRouter>
  );
}
